import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import JSZip from "jszip";

function ReferredUserView() {
  const [searchParams] = useSearchParams();
  const RequestId = searchParams.get("id");
  const [users, setUser] = useState(null);
  const [campaignInfo, setcampaignInfo] = useState(null); // State to hold campaignInfo
  const [errorMessage, setErrorMessage] = useState(null); // State for error handling

  useEffect(() => {
    if (RequestId) {
      fetchData(RequestId);
    }
  }, [RequestId]);

  const fetchData = async (RequestId) => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userAdditionalInfo",
          module: "user",
          userId: RequestId,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        console.log("data.result.userDetails[0].user",data.result.userDetails[0].user)
        console.log("data.result.userDetails[0].user1",JSON.parse(data.result.userDetails[0].user.campaignInfo))
        setUser(data.result.userDetails[0].user);
        setcampaignInfo(JSON.parse(data.result.userDetails[0].user.campaignInfo));
      } else {
        console.error("Failed to fetch geotags:", data);
        setcampaignInfo(null); // Set null in case of failure
        setErrorMessage("Failed to load data.");
      }
    } catch (error) {
      console.error("Error fetching geotag data:", error);
      setcampaignInfo(null); // Set null in case of error
      setErrorMessage("Error fetching geotag data.");
    }
  };

  // Check if campaignInfo is available before rendering
  if (!campaignInfo) {
    return <div>{errorMessage || "Loading..."}</div>;
  }

  const formatFileName = (fileName) => {
    const extension = fileName.split(".").pop();
    let baseName = fileName;

    if (fileName.length > 10) {
      baseName = fileName.substring(0, 6);
      return `${baseName}...${extension}`;
    } else {
      return fileName;
    }
  };
  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  {users?.countryCode} {users?.mobile}
                </h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <a href="/users">
                      <i className="fa-solid fa-arrow-left-long mr-2" />
                      Back
                    </a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                          Marketing Title
                          </label>
                          <div className="col-12 col-md-8">
                            {campaignInfo?.marketingTitle || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                          Description
                          </label>
                          <div className="col-12 col-md-8">
                           
                              {campaignInfo?.ogDescription || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                          campaign
                          </label>
                          <div className="col-12 col-md-8">
                            {campaignInfo?.campaign || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Channel
                          </label>
                          <div className="col-12 col-md-8">
                            {campaignInfo.channel || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-5">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Referring Link</label>
                          <div className="col-12 col-md-8">
                           
                            <a
                              href={campaignInfo.referringLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                             {campaignInfo.referringLink || "N/A"}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ReferredUserView;
